import React from "react";
import { motion } from "framer-motion";
import founderImg from "../Assests/cropped_circle_image (1).png";
import team1 from "../Assests/yeolemam.jpeg";
import team2 from "../Assests/ghorpadesir.jpeg";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const About = () => {
  return (
    <div className="py-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* CARD WRAPPER */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-200">

          {/* HEADER BANNER */}
          <div className="relative h-64 md:h-80">
            <img
              src="https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1200&h=400&fit=crop"
              alt="About YCC Pattern"
              className="w-full h-full object-cover"
            />

            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-primary/70 to-primary/40 flex items-center justify-center backdrop-blur-sm">
              <h1 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg text-center">
                About Yeole Classes
              </h1>
            </div>
          </div>

          {/* MAIN CONTENT */}
          <div className="p-10">

            {/* STORY + MISSION */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14">
              
              {/* STORY */}
              <motion.div variants={fadeUp} initial="hidden" whileInView="show">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>

                <p className="text-gray-600 mb-4 leading-relaxed">
                  Yeole Classes was founded with a vision to shape the future of students
                  preparing for medical and engineering entrance exams. From a small classroom,
                  we have grown into a trusted brand guiding thousands of young achievers.
                </p>

                <p className="text-gray-600 mb-4 leading-relaxed">
                  With over <strong className="text-primary">80,000+ students</strong> trained, our
                  journey reflects dedication, innovation, and excellence in education.
                </p>

                <p className="text-gray-600 leading-relaxed">
                  Our goal is to empower every student with the skills, confidence, and guidance
                  needed to turn their dreams into reality.
                </p>
              </motion.div>

              {/* MISSION */}
              <motion.div variants={fadeUp} initial="hidden" whileInView="show">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Mission</h2>

                <div className="space-y-6">

                  {[
                    { icon: "🎯", title: "Excellence in Education", desc: "Deliver world-class coaching with expert faculty." },
                    { icon: "💡", title: "Innovation", desc: "Integrate advanced teaching methods & digital tools." },
                    { icon: "🤝", title: "Student Success", desc: "Focus on personal growth & conceptual clarity." },
                    { icon: "🌟", title: "Quality", desc: "Offer consistent, high-quality academic support." },
                  ].map((item, i) => (
                    <motion.div
                      key={i}
                      whileHover={{ scale: 1.03 }}
                      className="flex items-start bg-gray-100 px-4 py-3 rounded-xl shadow-sm"
                    >
                      <span className="text-primary text-3xl mr-4">{item.icon}</span>
                      <div>
                        <h3 className="font-semibold text-gray-900">{item.title}</h3>
                        <p className="text-gray-600 text-sm">{item.desc}</p>
                      </div>
                    </motion.div>
                  ))}

                </div>
              </motion.div>

            </div>

            {/* FOUNDER SECTION */}
            <div className="mt-20">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-10 text-center">
                Founder & Director
              </h2>

              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.7 }}
                className="bg-gradient-to-r from-primary/10 via-white to-primary/10 p-10 rounded-3xl shadow-xl"
              >

                <div className="flex flex-col md:flex-row items-center gap-10">

                  {/* Image */}
                  <div className="md:w-1/3 flex justify-center">
                    <motion.div whileHover={{ scale: 1.05 }} className="relative">
                      <img
                        src={founderImg}
                        alt="Founder"
                        className="w-56 h-56 rounded-full shadow-xl border-4 border-white object-cover"
                      />
                      <div className="absolute inset-0 rounded-full bg-primary/20 blur-2xl opacity-70 -z-10"></div>
                    </motion.div>
                  </div>

                  {/* Info */}
                  <motion.div
                    className="md:w-2/3"
                    initial={{ x: 50, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.7 }}
                  >
                    <h3 className="text-3xl font-bold text-gray-900 mb-2">
                      Prof. Vijay Yeole
                    </h3>

                    <div className="pl-4 border-l-4 border-primary mb-4">
                      <p className="text-primary font-semibold text-lg">M.Sc. Mathematics, B.Ed., MBA (IT)</p>
                      <p className="text-primary/80 font-medium">
                        Founder & Director — Yeole Classes Pattern
                      </p>
                    </div>

                    <p className="text-gray-700 mb-4 leading-relaxed">
                      With over <strong>13 years of expertise</strong> in NEET & JEE coaching,
                      Prof. Yeole is known for his conceptual clarity, motivational teaching,
                      and exceptional student guidance.
                    </p>

                    <p className="text-gray-700 leading-relaxed">
                      Under his leadership, Yeole Classes has trained
                      <strong className="text-primary"> 10,000+ students</strong> for successful careers.
                    </p>
                  </motion.div>

                </div>
              </motion.div>
            </div>


            {/* TEAM SECTION */}
            <div className="mt-24 pt-12 border-t border-gray-300">
              <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">
                Meet Our Team
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-3xl mx-auto">

                {/* Member Cards */}
                {[{
                  img: team1,
                  name: "Prof. Divya Yeole",
                  role: "Managing Director",
                  detail: "M.Sc. Biology",
                }
              // ,{
              //     img: team2,
              //     name: "Prof. Ghorpade Sir",
              //     role: "Faculty of Physics",
              //     detail: "BE Mechanical — Technical Advisor at IQVIA RDS INDIA PVT LTD",
              //   }
              ].map((m, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ scale: 1.05, boxShadow: "0 10px 35px rgba(0,0,0,0.15)" }}
                    className="text-center bg-white p-8 rounded-2xl shadow-md transition"
                  >
                    <img src={m.img} className="w-32 h-32 rounded-full mx-auto mb-4 object-cover shadow-lg" />

                    <h3 className="text-xl font-bold text-gray-900">{m.name}</h3>
                    <p className="text-primary font-medium">{m.role}</p>
                    <p className="text-gray-600 mt-1 text-sm">{m.detail}</p>
                  </motion.div>
                ))}

              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default About;
